//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TabColumnView',
  props: {
    item: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      filtro: '',
      fields: [{
        key: 'table_id',
        label: 'Table',
        class: 'w-15'
      }, {
        key: 'name',
        label: 'Column',
        class: 'w-10'
      }, {
        key: 'business_definition',
        label: 'Business Definition'
      }, {
        key: 'field_name',
        label: 'Original column',
        class: 'w-10'
      }, {
        key: 'datatype',
        label: 'Datatype',
        class: 'w-5'
      }, {
        key: 'visualization_type',
        label: 'Visualization Type',
        class: 'w-8 text-center'
      }, {
        key: 'calculate_field',
        label: 'Calculated Field?',
        class: 'w-3 text-center'
      }, {
        key: 'formula',
        label: 'Formula',
        class: 'w-20'
      }, {
        key: 'sensitive_data',
        label: 'Sensitive?',
        class: 'w-3 text-center'
      }, {
        key: 'masked',
        label: 'Masked?',
        class: 'w-3 text-center'
      }]
    };
  }
};